export default __webpack_public_path__ + "static/media/Group 6492.4c8ff07c.svg";